import ClickAwayListener from '@mui/material/ClickAwayListener'
import MuiTooltip, {
  TooltipProps as MuiTooltipProps
} from '@mui/material/Tooltip'

import CloseIcon from 'app/assets/icons/close-light-icon-.svg'
import Box from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import useModal from 'app/hooks/useModal'

interface TooltipProps extends Omit<MuiTooltipProps, 'content' | 'title'> {
  content: MuiTooltipProps['title']
  isCloseButton?: boolean
}

const TooltipWithClose: RFC<TooltipProps> = ({
  content,
  children,
  ...restProps
}) => {
  const { hideModal, open, showModal } = useModal()

  return (
    <ClickAwayListener onClickAway={hideModal}>
      <Box>
        <MuiTooltip
          open={open}
          onOpen={showModal}
          onMouseOver={showModal}
          title={
            <Box display="flex">
              {content}

              <IconButton sx={{ height: '16px', p: 0 }} onClick={hideModal}>
                <CloseIcon />
              </IconButton>
            </Box>
          }
          {...restProps}
        >
          <Box>{children}</Box>
        </MuiTooltip>
      </Box>
    </ClickAwayListener>
  )
}

const Tooltip: RFC<TooltipProps> = ({
  content,
  isCloseButton,
  children,
  ...restProps
}) => {
  if (isCloseButton) {
    return (
      <TooltipWithClose content={content} {...restProps}>
        {children}
      </TooltipWithClose>
    )
  }

  return (
    <MuiTooltip title={content} {...restProps}>
      <Box>{children}</Box>
    </MuiTooltip>
  )
}

export default Tooltip
